// @flow
'use strict';

import { connect } from 'react-redux';

import { abreModal } from '../../../../../reducers/modal_exportacao_lote';

import BotaoExportacaoLoteNfe from './botao_exportacao_lote_nfe';

const mapDispatchToProps = {
  abreModalPdf: () => abreModal('pdf', 'nfe'),
  abreModalXml: () => abreModal('xml', 'nfe'),
}

export default connect<*, *, *, *, *, *>(null, mapDispatchToProps)(BotaoExportacaoLoteNfe);
